import React from "react";
import "./landing.css";

const FEATURES = [
  {
    title: "On your schedule",
    body: "Once your order is approved, our team gets it moving. What sets us apart from other suppliers is that you tell us the time of day that works — before service, not during it.",
    icon: <TruckIcon />,
  },
  {
    title: "Cash on delivery",
    body: "No accounts to settle in advance and no paperwork to chase. You pay when the crates arrive and you have checked them.",
    icon: <CashIcon />,
  },
  {
    title: "Drivers who know the route",
    body: "The condition and timing of your stock decides your service. Our drivers are trained, punctual and answerable for every delivery they make.",
    icon: <RouteIcon />,
  },
];

export default function Delivery() {
  return (
    <section className="tfm-section tfm-section--field" id="delivery">
      <div className="tfm-container">
        <div className="tfm-section-head">
          <p className="tfm-eyebrow">Delivery</p>
          <h2 className="tfm-h2" style={{ marginTop: "1.1rem" }}>
            It arrives before you need it.
          </h2>
        </div>

        <div className="tfm-delivery__grid">
          {FEATURES.map((feature) => (
            <article className="tfm-delivery__item" key={feature.title}>
              <div className="tfm-delivery__icon">{feature.icon}</div>
              <h3 className="tfm-delivery__title">{feature.title}</h3>
              <p className="tfm-delivery__body">{feature.body}</p>
            </article>
          ))}
        </div>

        <div className="tfm-route">
          <span className="tfm-route__pin">Kalamoun</span>
          <span className="tfm-route__line" aria-hidden="true" />
          <span className="tfm-route__pin">Greater Tripoli</span>
          <span className="tfm-route__line" aria-hidden="true" />
          <span className="tfm-route__pin">Menniye</span>
          <p className="tfm-route__note">
            That is our delivery zone today. Outside it?{" "}
            <a href="tel:+96171144332" style={{ textDecoration: "underline" }}>
              Call us
            </a>{" "}
            and we will see what we can arrange.
          </p>
        </div>
      </div>
    </section>
  );
}

const stroke = {
  stroke: "currentColor",
  strokeWidth: 1.7,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none",
};

function TruckIcon() {
  return (
    <svg width="30" height="30" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M3 7h10v9H3zM13 11h4.5l3.5 4v1h-8" {...stroke} />
      <circle cx="7" cy="17.5" r="1.9" {...stroke} />
      <circle cx="17" cy="17.5" r="1.9" {...stroke} />
      <path d="M1 10h4M1 13h3" {...stroke} />
    </svg>
  );
}

function CashIcon() {
  return (
    <svg width="30" height="30" viewBox="0 0 24 24" aria-hidden="true">
      <rect x="2.5" y="6" width="19" height="12" rx="2" {...stroke} />
      <circle cx="12" cy="12" r="2.6" {...stroke} />
      <path d="M6 9.5v5M18 9.5v5" {...stroke} />
    </svg>
  );
}

function RouteIcon() {
  return (
    <svg width="30" height="30" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M6.5 3.5a3.5 3.5 0 0 1 3.5 3.5c0 2.4-3.5 6-3.5 6S3 9.4 3 7a3.5 3.5 0 0 1 3.5-3.5Z" {...stroke} />
      <path d="M17.5 11a3.5 3.5 0 0 1 3.5 3.5c0 2.4-3.5 6-3.5 6s-3.5-3.6-3.5-6a3.5 3.5 0 0 1 3.5-3.5Z" {...stroke} />
    </svg>
  );
}
